import { render, staticRenderFns } from "./MyTimer.vue?vue&type=template&id=54a4f75a&scoped=true"
import script from "./MyTimer.vue?vue&type=script&lang=js"
export * from "./MyTimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a4f75a",
  null
  
)

export default component.exports